@if (toasterService.toasts().length > 0) {
  <div class="flex flex-col gap-3 w-full overflow-y-auto height-auto">
    @for (toast of toasterService.toasts(); track toast.id) {
      <div
        class="pointer-events-auto bg-[#FCF0F0] flex flex-row shadow-lg animate__animated animate__fadeInRight animate__faster"
      >
        <!-- Left accent bar -->
        <div class="w-[5px] self-stretch flex-shrink-0 bg-[#E13829]"></div>

        <!-- Content -->
        <div class="flex flex-col flex-grow py-5 px-4">
          <!-- Title row -->
          <div class="flex items-start gap-3">
            <wu-icon name="errorIcon" class="flex-shrink-0 w-4 h-4" />
            <span
              class="flex-grow text-left text-[#444] font-['Mulish'] text-[14px] leading-[20px] font-bold whitespace-normal break-words cursor-default"
            >
              {{ toast.title }}
            </span>

            <!-- Close Button -->
            <button
              type="button"
              class="flex-shrink-0 text-[#444] mt-[2px]"
              aria-label="Dismiss notification"
              (click)="toasterService.dismiss(toast.id)"
            >
              <wu-icon
                name="recordsRegCloseIcon"
                class="flex-shrink-0 w-4 h-4"
              />
            </button>
          </div>

          <!-- Description (always visible) -->
          @if (toast.description) {
            <p
              class="toast-description mt-2 text-[#444] font-['Mulish'] cursor-default text-[14px] leading-[20px]"
              [innerHTML]="toast.description | htmlToTailwind"
            ></p>
          }
        </div>
      </div>
    }
  </div>
}
